import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import DashboardListDesktop from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardListDesktop/DashboardListDesktop';
import DashboardListMobile from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardListMobile/DashboardListMobile';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { useIsDesktop } from '@src/main/ui/components/common/ThemeProvider/useIsDesktop';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { type FC } from 'react';
import styles from './DashboardsList.module.scss';

interface Props {
  title?: string;
  dashboards: Dashboard[];
  isExpandable: boolean;
  highlighFields?: HighlighFields[];
  actions: {
    edit?: boolean;
    delete?: boolean;
    favorite?: boolean;
    info?: boolean;
  };
  onClickEdit?: (dashboard: Dashboard) => void;
  onClickDelete?: (dashboard: Dashboard) => void;
}

const defaultProps = {
  title: undefined,
  highlighFields: undefined,
  onClickEdit: undefined,
  onClickDelete: undefined,
};

const DashboardsList: FC<Props> = ({
  dashboards,
  title,
  isExpandable,
  highlighFields,
  actions,
  onClickEdit,
  onClickDelete,
}) => {
  const isDesktop = useIsDesktop();
  const { setSelectedDashboard } = useDashboardContext();
  const { toggleFavorite } = useUserContext();

  if (!dashboards.length) return <></>;
  return (
    <>
      <div className={styles.dashboardList}>
        {isDesktop ? (
          <DashboardListDesktop
            dashboards={dashboards}
            isExpandable={isExpandable}
            title={title}
            highlighFields={highlighFields}
            actions={actions}
            onClickEdit={(dashboard) => onClickEdit && onClickEdit(dashboard)}
            onClickDelete={(dashboard) => onClickDelete && onClickDelete(dashboard)}
            onClickShowMoreInfo={setSelectedDashboard}
            onClickFavorites={toggleFavorite}
          />
        ) : (
          <DashboardListMobile
            dashboards={dashboards}
            isExpandable={isExpandable}
            title={title}
            highlighFields={highlighFields}
            actions={actions}
            onClickEdit={setSelectedDashboard}
            onClickDelete={setSelectedDashboard}
            onClickShowMoreInfo={setSelectedDashboard}
            onClickFavorites={toggleFavorite}
          />
        )}
      </div>
    </>
  );
};

DashboardsList.defaultProps = defaultProps;

export default DashboardsList;
